module.exports = __webpack_public_path__ + "static/media/logo-supplydrop-orange.9aba21a2.svg";